import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import API, { getUploadUrl } from '../../services/api';

const Icon = ({ d, size = 22 }) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 24 24"
    stroke="currentColor" strokeWidth="1.8">
    <path strokeLinecap="round" strokeLinejoin="round" d={d}/>
  </svg>
);

const STATS_CFG = [
  { key:'magazines',   label:'Magazine Issues',  icon:'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253', accent:'#c9a84c', iconBg:'rgba(201,168,76,.12)',  link:'/admin/magazines'   },
  { key:'articles',    label:'Articles',          icon:'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',                                                                                                                                              accent:'#60a5fa', iconBg:'rgba(96,165,250,.12)',   link:'/admin/articles'    },
  { key:'subscribers', label:'Subscribers',       icon:'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z',                                                     accent:'#4ade80', iconBg:'rgba(74,222,128,.12)',   link:'/admin/subscribers' },
  { key:'uploads',     label:'Media Files',       icon:'M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z',                                                                                                       accent:'#a78bfa', iconBg:'rgba(167,139,250,.12)',  link:'/admin/uploads'     },
];

const DEMO_STATS = {
  magazines: 10, articles: 8, subscribers: 124, uploads: 32,
  recentSubs: [
    { email:'sarah.chen@example.com',   name:'Sarah Chen',   createdAt: new Date(Date.now()-1*3600000).toISOString()  },
    { email:'james.wright@example.com', name:'James Wright', createdAt: new Date(Date.now()-5*3600000).toISOString()  },
    { email:'priya.k@example.com',      name:'Priya K',      createdAt: new Date(Date.now()-12*3600000).toISOString() },
    { email:'marcus.b@example.com',     name:'Marcus B',     createdAt: new Date(Date.now()-24*3600000).toISOString() },
    { email:'elena.v@example.com',      name:'Elena V',      createdAt: new Date(Date.now()-48*3600000).toISOString() },
  ],
};

const DEMO_MAGS = [
  { title:'The Most Innovative Leader in Advanced Clinical Medicine – 2026', category:'healthcare', year:2026, imageUrl:'https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=80&h=80&fit=crop&q=80' },
  { title:'The Most Impactful HR Strategists to Watch in 2026',              category:'business',   year:2026, imageUrl:'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=80&h=80&fit=crop&q=80' },
  { title:'The Most Empowering Women Leaders To Watch In 2026',              category:'women',      year:2026, imageUrl:'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=80&h=80&fit=crop&q=80' },
  { title:'The Most Visionary Leader in Strategic Inspirational Leadership', category:'leadership', year:2026, imageUrl:'https://images.unsplash.com/photo-1556157382-97eda2f9e2bf?w=80&h=80&fit=crop&q=80' },
  { title:'The Most Impactful Leader In Education Sector – 2026',            category:'education',  year:2026, imageUrl:'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=80&h=80&fit=crop&q=80' },
];

function timeAgo(dateStr) {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60)    return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs  < 24)    return `${hrs}h ago`;
  return `${Math.floor(hrs/24)}d ago`;
}

export default function AdminDashboard({ admin }) {
  const [stats,   setStats]   = useState(null);
  const [loading, setLoading] = useState(true);
  const isDemoMode = localStorage.getItem('adminMode') === 'demo';

  useEffect(() => {
    if (isDemoMode) {
      setTimeout(() => { setStats(DEMO_STATS); setLoading(false); }, 600);
      return;
    }
    const token = localStorage.getItem('adminToken');
    const authH = { Authorization: `Bearer ${token}` };
    
    Promise.all([
      API.get('/admin/stats', { headers: authH }),
      API.get('/magazines', { params: { limit: 5 }, headers: authH })
    ])
      .then(([statsRes, magsRes]) => {
        const statsData = statsRes.data.data;
        setStats({
          ...statsData,
          recentMags: magsRes.data.data?.slice(0, 5) || []
        });
      })
      .catch(() => { setStats({ ...DEMO_STATS, recentMags: DEMO_MAGS }); })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      {/* Page header */}
      <div className="page-header">
        <div>
          <h1 className="page-title">
            Welcome back, {(admin?.name || 'Admin').split(' ')[0]} 👋
          </h1>
          <p className="page-subtitle">
            {isDemoMode
              ? '⚡ Demo mode — connect MongoDB to enable live data'
              : "Here's what's happening with your magazine platform today."
            }
          </p>
        </div>
        <div className="page-actions">
          <Link to="/admin/magazines" className="btn btn-primary">+ New Issue</Link>
        </div>
      </div>

      {/* Demo mode banner */}
      {isDemoMode && (
        <div style={{
          background:'rgba(201,168,76,.08)', border:'1px solid rgba(201,168,76,.22)',
          borderRadius:6, padding:'14px 20px', marginBottom:24,
          display:'flex', alignItems:'flex-start', gap:12,
        }}>
          <span style={{ fontSize:'1.2rem' }}>⚡</span>
          <div>
            <div style={{ fontWeight:600, color:'var(--gold)', fontSize:'.88rem', marginBottom:4 }}>
              Running in Demo Mode
            </div>
            <div style={{ fontSize:'.82rem', color:'var(--white70)', lineHeight:1.6 }}>
              The backend is not connected. All data shown is sample data.
              Run <code style={{ background:'rgba(255,255,255,.08)', padding:'1px 6px', borderRadius:3, fontSize:'.78rem' }}>npm run seed</code> and
              start the backend to use live data. All UI features are fully interactive.
            </div>
          </div>
        </div>
      )}

      {/* Stats cards */}
      <div className="stats-grid">
        {STATS_CFG.map(cfg => (
          <Link to={cfg.link} key={cfg.key} className="stat-card"
            style={{ '--accent': cfg.accent, '--icon-bg': cfg.iconBg, textDecoration:'none', display:'block' }}>
            <div className="stat-card-icon"><Icon d={cfg.icon}/></div>
            <div className="stat-card-val">
              {loading
                ? <span style={{ display:'inline-block', width:40, height:28, background:'var(--card2)', borderRadius:4, animation:'pulse 1.4s infinite' }}/>
                : (stats?.[cfg.key] ?? 0).toLocaleString()
              }
            </div>
            <div className="stat-card-lbl">{cfg.label}</div>
            <div className="stat-card-trend" style={{ color: cfg.accent }}>↑ view all</div>
          </Link>
        ))}
      </div>

      {/* Lower grid */}
      <div className="dash-grid">

        {/* Recent Magazines */}
        <div className="table-card">
          <div className="table-header">
            <span className="table-title">Recent Magazine Issues</span>
            <Link to="/admin/magazines" className="btn btn-sm btn-secondary">View All →</Link>
          </div>
          {loading ? (
            <div style={{ padding:'20px 24px', display:'flex', flexDirection:'column', gap:12 }}>
              {[1,2,3,4,5].map(i => (
                <div key={i} style={{ display:'flex', gap:12, alignItems:'center' }}>
                  <div style={{ width:44, height:44, borderRadius:4, background:'var(--card2)', flexShrink:0, animation:'pulse 1.4s infinite' }}/>
                  <div style={{ flex:1 }}>
                    <div style={{ height:12, background:'var(--card2)', borderRadius:3, marginBottom:6, animation:'pulse 1.4s infinite' }}/>
                    <div style={{ height:10, background:'var(--card2)', borderRadius:3, width:'55%', animation:'pulse 1.4s infinite' }}/>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="recent-list">
              {(stats?.recentMags || []).map((m, i) => (
                <div key={m._id || i} className="recent-item">
                  <img src={getUploadUrl(m.imageUrl)} alt="" className="recent-item-img" 
                    onError={e => e.target.style.display='none'}/>
                  <div className="recent-item-info">
                    <div className="recent-item-title">{m.title}</div>
                    <div className="recent-item-meta">{m.category} · {m.year}</div>
                  </div>
                  <span className="badge badge-gold">{m.category}</span>
                </div>
              ))}
              {(!stats?.recentMags || stats.recentMags.length === 0) && (
                <div className="empty-state" style={{ padding: '20px 0' }}>
                  <div className="empty-sub">No magazine issues yet.</div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Recent Subscribers */}
        <div className="table-card">
          <div className="table-header">
            <span className="table-title">New Subscribers</span>
            <Link to="/admin/subscribers" className="btn btn-sm btn-secondary">View All →</Link>
          </div>
          {loading ? (
            <div style={{ padding:'20px 24px', display:'flex', flexDirection:'column', gap:12 }}>
              {[1,2,3,4,5].map(i => (
                <div key={i} style={{ display:'flex', gap:10, alignItems:'center' }}>
                  <div style={{ width:32, height:32, borderRadius:'50%', background:'var(--card2)', flexShrink:0, animation:'pulse 1.4s infinite' }}/>
                  <div style={{ flex:1 }}>
                    <div style={{ height:10, background:'var(--card2)', borderRadius:3, animation:'pulse 1.4s infinite' }}/>
                  </div>
                </div>
              ))}
            </div>
          ) : stats?.recentSubs?.length ? (
            <div className="sub-list">
              {stats.recentSubs.map((s, i) => (
                <div key={i} className="sub-item">
                  <div className="sub-avatar">{(s.name||s.email)[0].toUpperCase()}</div>
                  <span className="sub-email">{s.email}</span>
                  <span className="sub-date">{timeAgo(s.createdAt)}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <div className="empty-icon">
                <Icon d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" size={26}/>
              </div>
              <div className="empty-title">No subscribers yet</div>
              <div className="empty-sub">Subscribers will appear here once people sign up on the site.</div>
            </div>
          )}
        </div>
      </div>

      {/* Quick actions */}
      <div style={{ marginTop:20 }}>
        <div className="table-card">
          <div className="table-header">
            <span className="table-title">Quick Actions</span>
          </div>
          <div style={{ padding:'20px 24px', display:'flex', gap:12, flexWrap:'wrap' }}>
            {[
              { label:'+ New Magazine Issue', to:'/admin/magazines', accent:'#c9a84c' },
              { label:'+ New Article',        to:'/admin/articles',  accent:'#60a5fa' },
              { label:'Upload Media',         to:'/admin/uploads',   accent:'#a78bfa' },
              { label:'+ New Trend',          to:'/admin/trends',    accent:'#4ade80' },
            ].map(a => (
              <Link key={a.label} to={a.to}
                style={{
                  padding:'10px 20px', borderRadius:'var(--r)',
                  border:`1px solid ${a.accent}30`,
                  background:`${a.accent}0d`,
                  color: a.accent,
                  fontSize:'.82rem', fontWeight:600, letterSpacing:'.04em',
                  textDecoration:'none',
                  transition:'background .2s, transform .2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.background=`${a.accent}1a`; e.currentTarget.style.transform='translateY(-1px)'; }}
                onMouseLeave={e => { e.currentTarget.style.background=`${a.accent}0d`; e.currentTarget.style.transform=''; }}
              >
                {a.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%,100% { opacity:1; }
          50%      { opacity:.4; }
        }
      `}</style>
    </div>
  );
}
